import React from 'react';
import { BookOpenIcon, ClockIcon, HeartHandshakeIcon, ListChecksIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = {
  clock: ClockIcon,
  book: BookOpenIcon,
  list: ListChecksIcon,
  heart: HeartHandshakeIcon
};
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-brand-blue" data-id="element-16" data-mp="3nnqa9szf3bjs">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="38rr4iozs5nht">
        <h2 id="beneficios" className="font-display text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-18" data-mp="3dr3on1z9oggp">
          ¿Qué puede cambiar cuando empezás?
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/85" data-id="element-19" data-mp="34qffakktj4a5">
          Una planificación organizada puede transformar tu manera de preparar
          las clases.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="12z28tr37cobz">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[benefit.icon];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border border-white/15 bg-white/10 p-2.5 text-left" data-id="element-21" data-mp="2bdcq7g9739we" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-brand-yellow" data-id="element-22" data-mp="2g65vc58ksk90">
                  <Icon size={15} className="text-brand-blue" data-id="element-23" data-mp="1sfjnadykmzz0" />
                </span>
                <div data-id="element-24" data-mp="1of83f3e193ol">
                  <h3 className="text-sm font-bold uppercase leading-tight text-brand-yellow" data-id="element-25" data-mp="1ofrkyizrtq23">
                    {benefit.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-white/85 sm:text-sm" data-id="element-26" data-mp="1xfecmd2p7hhy">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}